import App from 'next/app'
import React from 'react'
import { ThemeProvider } from 'styled-components'
import * as Sentry from '@sentry/nextjs'
import { withRouter } from 'next/router'
import { initAmplitude } from '../services/amplitude'

import { GlobalStyle as NewGlobalStyle } from 'styles/GlobalStyles'
import NewTheme from 'styles/theme'

import 'survey-react/survey.css'
import 'survey-react/modern.css'
import 'jquery-ui/themes/base/all.css'
import { AmplitudeExperimentProvider } from 'components/AmplitudeExperiments/AmplitudeExperimentProvider'
import CookiePolicy from 'components/CookiePolicy'

interface Props {
  Component: React.ReactElement
  pageProps: Record<string, unknown>
}

export class MyApp extends App<Props> {
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.withScope(scope => {
      scope.setExtra('componentStack', errorInfo.componentStack)
      Sentry.captureException(error)
    })
  }

  async componentDidMount() {
    initAmplitude()
  }

  render() {
    const { Component, pageProps } = this.props

    return (
      <AmplitudeExperimentProvider>
        <ThemeProvider theme={NewTheme}>
          <NewGlobalStyle />
          <Component {...pageProps} />
          <CookiePolicy />
        </ThemeProvider>
      </AmplitudeExperimentProvider>
    )
  }
}

export default withRouter(MyApp)
